export const actions = {
    event(vuex, payload) {
        return this.$axios.$post('/api/v1/users/me/event', { event: payload })
    },
}
